export default[
    {
        path: '/tabelapreco/rublica/evento/cadastro/:rublica_id',
        name: 'cadastro do evento da rublicas', 
        component: () => import(/* webpackChunkName: "Login" */ './page/cadastro.vue')
    },
    {
        path: '/tabelapreco/rublica/evento/lista/:rublica_id',
        name: 'lista evento da rublicas', 
        component: () => import(/* webpackChunkName: "Login" */ './page/lista.vue')
    },
    {
        path: '/tabelapreco/rublica/evento/editar/:rublica_id',
        name: 'editar evento da rublicas', 
        component: () => import(/* webpackChunkName: "Login" */ './page/editar.vue')
    },
]